import type { UnlikelySfCustomer } from "@unlikelystudio/commerce-connector"

import type { Nullish } from "~/@types/generics"
import { getReferenceIdFromGID } from "~/lib/shopify/utils/id"
import type { TVariant } from "~/components/ui/ProductHeader/_data/types"
import type { CartLineItemPayload } from "~/components/shared/AnalyticsEvents/types"
import { processVpPrice } from "~/utils/vp-prices/process-vp-prices"

export function variantToTrackingData(
  variant: TVariant | null,
  customer?: Nullish<UnlikelySfCustomer>
): Pick<CartLineItemPayload, "item_variant" | "price" | "discount" | "item_variant_id"> | null {
  if (!variant) return null

  const { processedPrice, processedCompareAtPrice } = processVpPrice({
    price: variant?.price,
    compareAtPrice: variant?.compareAtPrice,
    vpPrice: variant?.vpPrice,
    customer,
  })

  return {
    item_variant: variant?.sku ?? "",
    price: processedPrice?.amount ?? 0,
    discount: processedCompareAtPrice?.amount
      ? (processedCompareAtPrice?.amount ?? 0) - (processedPrice?.amount ?? 0)
      : 0,
    item_variant_id: String(getReferenceIdFromGID(variant?.id)) ?? null,
  }
}
